import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind('[data-fancybox]', {
    animated: true,
    showClass: 'f-zoomInUp',
    hideClass: 'f-fadeOut',

    l10n: {
        CLOSE: 'Закрыть',
        NEXT: 'Далее',
        PREV: 'Назад',
        ZOOM: 'Увеличить',
    },

    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ['close'],
        },
    },

    on: {
        ready: () => {
            if (window.utils?.ajaxReload) {
                window.utils.ajaxReload();
            }
        },
    },
});

export { Fancybox };